<template>
  <v-content>
    <v-container my-10>
      <v-layout align-center justify-center>
        <v-progress-circular
          :size="55"
          :width="4"
          indeterminate
          color="primary"
          class="mt-12"
          v-if="loading"
        ></v-progress-circular>
        <v-card v-else max-width="650px">
          <div class="d-flex flex-wrap">
            <div>
              <v-card-title>
                <span class="headline" v-copy>{{ getBoatName }}</span>
                <!-- <v-spacer></v-spacer> -->
              </v-card-title>
              <v-card-subtitle>
                {{ editedItem.boat_name }}
              </v-card-subtitle>
            </div>
            <v-spacer></v-spacer>
            <div>
              <v-card-actions class="mt-2">
                <v-btn
                  v-if="canUseImpersonate"
                  color="primary"
                  text
                  @click="handleImpersonate"
                >
                  <span v-if="editedItem.is_imper_in_use">
                    {{ $t("builder.boats.details.temporaryAccessEnabled") }}
                  </span>
                  <span v-else>
                    {{ $t("builder.boats.details.enableTemporaryAccess") }}
                  </span>
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  v-if="canUseReset"
                  :disabled="editedItem.device === null"
                  @click="reset()"
                >
                  <v-icon small class="mx-2">mdi-rotate-right</v-icon>
                  {{ $t("builder.boats.details.reset") }}
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  v-if="canUseImport && editedItem.device !== null"
                  @click="refresh()"
                >
                  <v-icon small class="mx-2">mdi-update</v-icon>
                  {{ $t("builder.boats.details.re-Sync") }}
                </v-btn>
                <v-btn text color="primary" @click="edit()"
                  ><v-icon small class="mx-2">mdi-pencil</v-icon>
                  {{ $t("builder.boats.details.edit") }}
                </v-btn>
                <v-btn
                  text
                  color="red"
                  v-if="canUserDelete"
                  @click="deleteFn()"
                >
                  <v-icon small class="mx-2">mdi-delete</v-icon>
                  {{ $t("builder.boats.details.delete") }}
                </v-btn>
              </v-card-actions>
            </div>
          </div>

          <div>
            <pin-banner class="mb-2" :show-banner="showPinBanner"> </pin-banner>
            <retrofit-banner
              class="mb-2"
              :show-banner="showRetrofitStatus"
              @update:retrofit-banner="updateRetrofitBanner"
              v-if="getClientIDs.id === 'sentinel'"
            ></retrofit-banner>
            <kyc-banner
              v-if="kycBanner.active"
              :banner="kycBanner"
              :isLite="editedItem.device.is_lite"
              :previousUser="editedItem.handout_status.current_user_email"
              @close="handleKycBanner"
            ></kyc-banner>
          </div>

          <v-card-text class="mt-0 pt-0">
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12" lg="12">
                  <v-card elevation="0">
                    <v-card-title class="subtitle-1">
                      {{ $t("builder.boats.details.slotNumber") }}
                      :</v-card-title
                    >
                    <v-card-subtitle>
                      {{ editedItem.slot_number }}</v-card-subtitle
                    >
                  </v-card>
                </v-col>
                <v-col cols="12" sm="12" md="12" lg="12">
                  <v-card elevation="0">
                    <v-card-title class="subtitle-1">
                      {{ $t("builder.boats.details.HIN") }} :</v-card-title
                    >
                    <v-card-subtitle>
                      {{ editedItem.ce_number }}</v-card-subtitle
                    >
                  </v-card>
                </v-col>
                <v-col cols="12" sm="12" md="12" lg="12">
                  <v-card elevation="0">
                    <v-card-actions class="mb-0 pb-0">
                      <v-list width="100%">
                        <v-list-item class="mx-2 px-0">
                          <v-list-item-content>
                            <v-list-item-title>
                              {{
                                $t("builder.boats.details.sentinelSN")
                              }}:</v-list-item-title
                            >
                            <v-list-item-subtitle
                              v-if="editedItem.device !== null"
                              >{{ editedItem.device.name }}
                              {{ isLiteBoat }}
                            </v-list-item-subtitle>
                          </v-list-item-content>
                          <v-btn
                            v-if="editedItem.device !== null"
                            color="primary"
                            text
                            @click="previewQrCode"
                            ><v-icon class="mr-2"> mdi-qrcode </v-icon>
                            {{ $t("builder.boats.details.qrCode") }}
                          </v-btn>
                          <qrcode
                            v-if="editedItem.device !== null"
                            :value="editedItem.device.qr_hash"
                            :options="{ width: 500 }"
                            tag="img"
                            style="display: none"
                            ref="qrCode"
                          ></qrcode>
                        </v-list-item>
                      </v-list>
                    </v-card-actions>
                  </v-card>
                </v-col>

                <v-col cols="12" sm="12" md="12" lg="12">
                  <v-card elevation="0">
                    <v-card-title class="subtitle-1">
                      {{ $t("builder.boats.details.model") }}:</v-card-title
                    >
                    <v-card-subtitle>
                      {{
                        editedItem.model.brand_name +
                        " " +
                        editedItem.model.model
                      }}
                    </v-card-subtitle>
                  </v-card>
                </v-col>

                <v-col cols="12" sm="12" md="12" lg="12">
                  <v-card elevation="0" pa-1 ma-1>
                    <v-card-title class="subtitle-1">
                      {{ $t("builder.boats.details.parts") }}:</v-card-title
                    >
                    <v-card-subtitle class="pb-0">
                      <boat-item-list
                        v-if="initialBoatItemsData.data.results.length !== 0"
                        :initialData="initialBoatItemsData"
                        :readonly="true"
                        :disable-selector="
                          editableFields('boat_items_to_create')
                        "
                        :disable-adding="editableFields('boat_items_to_update')"
                        :disable-deleting="
                          editableFields('boat_items_to_delete')
                        "
                      ></boat-item-list>
                      <span v-else>
                        {{ $t("builder.boats.details.noEquipment") }}
                      </span>
                    </v-card-subtitle>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="12" md="12" lg="12">
                  <v-card elevation="0" pa-1 ma-1>
                    <v-card-title class="subtitle-1">
                      {{
                        $t("builder.boats.details.standardDocuments")
                      }}:</v-card-title
                    >
                    <v-card-subtitle>
                      <document-picker
                        :documents="serialDocuments"
                        :preview="true"
                        :unavailable-documents="[]"
                        :readonly="true"
                        feature="template"
                      />
                    </v-card-subtitle>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="12" md="12" lg="12">
                  <v-card elevation="0" pa-1 ma-1>
                    <v-card-title class="subtitle-1">
                      {{
                        $t("builder.boats.details.customDocuments")
                      }}:</v-card-title
                    >
                    <v-card-subtitle>
                      <document-picker
                        :documents="customDocuments"
                        :preview="true"
                        :unavailable-documents="[]"
                        :readonly="true"
                        feature="template"
                      />
                    </v-card-subtitle>
                  </v-card>
                </v-col>

                <v-col cols="12" sm="12" md="12" lg="12">
                  <v-card elevation="0">
                    <v-card-actions class="mb-0 pb-0">
                      <v-list width="100%">
                        <v-list-item class="mx-2 px-0">
                          <v-list-item-content>
                            <v-list-item-title>
                              {{
                                $t("builder.boats.details.salesPartner")
                              }}:</v-list-item-title
                            >

                            <v-list-item-subtitle>
                              {{ editedItem.sales_dealer.name }}
                            </v-list-item-subtitle>
                          </v-list-item-content>
                          <!-- v-if="editedItem.device !== null" -->
                          <v-btn
                            color="primary"
                            @click="openSalesDealer"
                            link
                            text
                            :to="openSalesDealer"
                            v-if="canSeeSalesDealer"
                            ><v-icon class="mr-2"> mdi-information </v-icon>
                            {{ $t("builder.boats.details.details") }}
                          </v-btn>
                        </v-list-item>
                      </v-list>
                    </v-card-actions>
                  </v-card>
                </v-col>

                <v-col cols="12" sm="12" md="12" lg="12">
                  <v-card elevation="0">
                    <v-card-actions class="mb-0 pb-0">
                      <v-list width="100%">
                        <v-list-item class="mx-2 px-0">
                          <v-list-item-content>
                            <v-list-item-title>
                              {{
                                $t(
                                  "builder.boats.details.servicingPartnerCustomerService"
                                )
                              }}:</v-list-item-title
                            >

                            <v-list-item-subtitle>
                              {{ editedItem.responsive_dealer.name }}
                            </v-list-item-subtitle>
                          </v-list-item-content>
                          <!-- v-if="editedItem.device !== null" -->
                          <v-btn
                            color="primary"
                            link
                            text
                            :to="openResponsiveDealer"
                            v-if="canSeeResponsiveDealer"
                            ><v-icon class="mr-2"> mdi-information </v-icon>
                            {{ $t("builder.boats.details.details") }}
                          </v-btn>
                        </v-list-item>
                      </v-list>
                    </v-card-actions>
                  </v-card>
                </v-col>

                <v-col cols="12" sm="12" md="12" lg="12">
                  <v-card elevation="0">
                    <v-card-title class="subtitle-1"
                      >{{
                        $t("builder.boats.details.deliveryDateToPartner")
                      }}:</v-card-title
                    >
                    <v-card-subtitle>
                      {{
                        editedItem.delivery_date
                          ? editedItem.delivery_date.substring(0, 10)
                          : ""
                      }}</v-card-subtitle
                    >
                  </v-card>
                </v-col>

                <v-col cols="12" sm="12" md="12" lg="12">
                  <v-card elevation="0">
                    <v-card-title class="subtitle-1"
                      >{{
                        $t("builder.boats.details.deliveryDateToCustomer")
                      }}:</v-card-title
                    >
                    <v-card-subtitle>
                      {{
                        editedItem.delivery_date_to_customer
                          ? editedItem.delivery_date_to_customer.substring(
                              0,
                              10
                            )
                          : ""
                      }}</v-card-subtitle
                    >
                  </v-card>
                </v-col>

                <v-col cols="12" sm="12" md="12" lg="12">
                  <v-card elevation="0">
                    <v-card-title class="subtitle-1"
                      >{{
                        $t("builder.boats.details.subscriptionStatus")
                      }}:</v-card-title
                    >
                    <v-card-subtitle>
                      {{ getSubscriptionStatus.text }}
                    </v-card-subtitle>
                  </v-card>
                </v-col>

                <v-col cols="12" sm="12" md="12" lg="12">
                  <v-card elevation="0">
                    <v-card-title class="subtitle-1"
                      >{{
                        $t("builder.boats.details.installation")
                      }}:</v-card-title
                    >
                    <v-card-subtitle>
                      {{ getRetrofitStatus }}
                    </v-card-subtitle>
                  </v-card>
                </v-col>

                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  lg="12"
                  v-if="editedItem.for_rental"
                >
                  <v-card elevation="0">
                    <v-card-title class="subtitle-1"
                      >{{ $t("builder.boats.details.usage") }}:</v-card-title
                    >
                    <v-card-subtitle>
                      {{ $t("builder.boats.details.commercial") }}
                    </v-card-subtitle>
                  </v-card>
                </v-col>

                <v-col cols="12" sm="12" md="12" lg="12">
                  <v-card elevation="0">
                    <v-card-actions class="mb-0 pb-0">
                      <v-list width="100%">
                        <v-list-item class="mx-2 px-0">
                          <v-list-item-content>
                            <v-list-item-title
                              >{{
                                $t("builder.boats.details.appUser")
                              }}:</v-list-item-title
                            >
                            <v-list-item-subtitle>{{
                              getHandoverStatus
                            }}</v-list-item-subtitle>
                            <v-list-item-subtitle
                              v-if="
                                editedItem.handout_status.current_user_email
                              "
                              >{{
                                editedItem.handout_status.current_user_email
                              }}</v-list-item-subtitle
                            >
                          </v-list-item-content>
                          <v-btn
                            v-if="
                              editedItem.handout_status.can_invite &&
                              editedItem.handout_status.current_user !==
                                'PENDING_TRANSFER'
                            "
                            @click="openTransferDialog"
                            text
                            color="primary"
                            ><v-icon small class="mr-2">mdi-autorenew</v-icon
                            >{{ $t("builder.boats.details.transfer") }}</v-btn
                          >
                          <v-btn
                            text
                            color="red"
                            v-if="
                              editedItem.handout_status.current_user ===
                              'PENDING_TRANSFER'
                            "
                            @click="openCancelTransferDialog"
                            ><v-icon small class="mr-2">mdi-close-circle</v-icon
                            >{{
                              $t("builder.boats.details.cancelTransfer")
                            }}</v-btn
                          >
                        </v-list-item>
                      </v-list>
                    </v-card-actions>
                  </v-card>
                </v-col>

                <v-col cols="12" sm="12" md="12" lg="12">
                  <v-card elevation="0">
                    <v-card-actions class="mb-0 pb-0">
                      <v-list width="100%">
                        <v-list-item class="mx-2 px-0">
                          <v-list-item-content>
                            <v-list-item-title>
                              {{
                                $t("builder.boats.details.diagnosticsReports")
                              }}:</v-list-item-title
                            >

                            <v-list-item-subtitle
                              v-if="!editedItem.has_installation_reports"
                            >
                              {{ $t("builder.boats.details.notAvailable") }}
                            </v-list-item-subtitle>
                          </v-list-item-content>
                          <!-- v-if="editedItem.device !== null" -->
                          <v-btn
                            color="primary"
                            text
                            @click="openDiagnosticsReports"
                            :disabled="!editedItem.has_installation_reports"
                            ><v-icon class="mr-2"> mdi-chart-box </v-icon>
                            {{ $t("builder.boats.details.show") }}
                          </v-btn>
                        </v-list-item>
                      </v-list>
                    </v-card-actions>
                  </v-card>
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  lg="12"
                  v-if="canSetCrmBoatTelematicsProfile"
                >
                  <v-card elevation="0" pa-1 ma-1 class="mb-0 pb-0">
                    <v-card-title class="subtitle-1 mb-0 pb-0">
                      {{ $t("builder.boats.details.advanced") }}:
                    </v-card-title>
                    <v-card elevation="0" class="mt-0 pt-0">
                      <v-card-title class="subtitle-1 mb-0 pb-0">
                        {{ $t("builder.boats.details.telematicsProfile") }}
                      </v-card-title>
                      <v-card-subtitle class="mt-0 pt-0">
                        <span
                          v-if="editedItem.selected_profile != null"
                          class="mt-1"
                        >
                          {{ editedItem.selected_profile.name }}
                        </span>
                        <span
                          v-if="editedItem.selected_profile == null"
                          class="mt-1"
                        >
                          {{ $t("builder.boats.details.noProfile") }}
                        </span>
                        <v-chip
                          outlined
                          v-if="isSelectedProfileModelsDefault"
                          class="ml-1"
                          >{{
                            $t("builder.boats.details.modelsDefault")
                          }}</v-chip
                        >
                        <v-chip
                          outlined
                          v-if="!isSelectedProfileModelsDefault"
                          class="ml-1"
                          >{{ $t("builder.boats.details.nonstandard") }}</v-chip
                        >
                      </v-card-subtitle>
                    </v-card>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="close">{{
              $t("builder.boats.details.cancel")
            }}</v-btn>
          </v-card-actions>
        </v-card>
        <delete-dialog
          :dialog="deleteDialog"
          :item="boatName"
          @agree="remove"
          v-show="false"
        />
        <warning-dialog
          :dialog="warningDialog"
          :item="editedItem"
          :text="
            $t(
              'builder.boats.details.thisWillSetResetSensorSelectionToDefaultProfileConfiguration'
            )
          "
          :title="$t('builder.boats.details.applySensorsProfile')"
          @agree="applyProfile(true)"
          v-show="false"
        />
        <warning-dialog
          :dialog="cancelTransferDialog.active"
          :item="editedItem"
          :text="
            $t(
              'builder.boats.details.areYouSureYouWantToCancelPendingBoatTransfer'
            )
          "
          :title="$t('builder.boats.details.cancelTransfer')"
          :confirm="$t('builder.boats.details.yes')"
          @agree="handleCancelTransfer"
          v-show="false"
        />
        <reset-boat-dialog
          :dialog="resetDialog"
          @agree="handleReset"
          v-show="false"
        >
        </reset-boat-dialog>
        <transfer-boat-dialog
          :dialog="transferDialog"
          @transfer="handleTransferDialog"
          :dealers-uuid="getDealersUuid"
          v-if="transferDialog.active"
          v-show="false"
        >
        </transfer-boat-dialog>
        <qr-code-preview-dialog
          v-show="false"
          :dialog="qrPreviewDialog"
          @close="handleQrPreviewDialog"
        ></qr-code-preview-dialog>
        <diagnostics-reports
          v-show="false"
          :dialog="diagnosticsReportDialog"
          @close="handleCloseDiagnosticsReport"
        ></diagnostics-reports>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
import api from "@/utils/api.js";
import DocumentPicker from "@/components/pickers/DocumentPicker";
import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
import WarningDialog from "@/components/dialogs/WarningDialog";
import TransferBoatDialog from "@/components/dialogs/TransferBoatDialog.vue";
import snackbar from "@/utils/snackbar";
import categories from "@/utils/categories.js";
import BoatItemList from "@/components/boat-items/BoatItemList.vue";
import QrCodePreviewDialog from "@/components/dialogs/QrCodePreviewDialog.vue";
import RetrofitBanner from "@/components/banners/RetrofitBanner.vue";
import KycBanner from "@/components/banners/KycBanner.vue";
import ResetBoatDialog from "@/components/dialogs/ResetBoatDialog";
import { mapGetters } from "vuex";
import restrictions from "@/utils/restrictions";
import PinBanner from "@/components/banners/PinBanner.vue";
import DiagnosticsReports from "@/components/miscellaneous/DiagnosticsReports.vue";

export default {
  components: {
    WarningDialog,
    DocumentPicker,
    DeleteDialog,
    BoatItemList,
    TransferBoatDialog,
    QrCodePreviewDialog,
    RetrofitBanner,
    ResetBoatDialog,
    PinBanner,
    DiagnosticsReports,
    KycBanner,
  },
  data: () => ({
    kycBanner: {
      active: false,
      content: null,
      slot_number: false,
      delivery_date: false,
      partner: false,
    },
    diagnosticsReportDialog: { active: false },
    loading: true,
    initialBoatItemsData: {},
    serialDocuments: [],
    customDocuments: [],
    availableDocuments: [],
    serialItems: [],
    categoryOptions: [],
    customItems: [],
    deleteDialog: false,
    boatName: null,
    warningDialog: false,
    resetDialog: { active: false, sentinelSn: "" },
    profileApplied: false,
    showTransferForm: false,
    showRetrofitStatus: { active: false, showPin: false, pin: null },
    showPinBanner: { active: false, pin: null },
    transferDialog: {
      active: false,
      activeUser: null,
    },
    qrPreviewDialog: {
      active: false,
      src: null,
      boat: {},
    },
    cancelTransferDialog: {
      active: false,
      text: "",
      title: "",
    },
    getDealersUuid: null,
    editedItem: {
      slot_number: "",
      ce_number: "",
      crm_group: null,
      device: null,
      device_serial: null,
      delivery_date: null,
      description: "",
      uuid: null,
      boat_items: [],
      documents: [],
      model_uuid: null,
      sales_dealer: null,
      responsive_dealer: null,
      is_imper_in_use: false,
    },
  }),

  computed: {
    canSetCrmBoatTelematicsProfile() {
      return !!restrictions.canUseUserFeature(
        "can_set_crm_boat_telematics_profile"
      );
    },
    isSelectedProfileModelsDefault() {
      const selectedProfileUuid =
        this.editedItem.selected_profile != null
          ? this.editedItem.selected_profile.uuid
          : null;
      const modelSelectedProfileUuid =
        this.editedItem.model.selected_profile != null
          ? this.editedItem.model.selected_profile.uuid
          : null;
      return selectedProfileUuid === modelSelectedProfileUuid;
    },
    ...mapGetters(["getMe", "getClientIDs"]),
    canUserDelete() {
      return this.getMe.menu_access.boats.write_groups.length !== 0;
    },
    canUseReset() {
      return restrictions.canUserUseRefreshBoat(this.editedItem.crm_group);
    },
    isLiteBoat() {
      if (
        this.editedItem.device.is_lite === null ||
        typeof this.editedItem.device.is_lite === undefined ||
        this.editedItem.device.is_lite === false
      ) {
        return "";
      }
      return "(" + this.$t("builder.boats.details.liteNonConnectedBoat") + ")";
    },
    canUseImport() {
      return restrictions.canUseCrmFeature("can_import_from_mis");
    },
    canUseImpersonate() {
      if (this.editedItem.features.length === 0) {
        return false;
      }

      let canUseImper = this.editedItem.features.find(
        (feature) =>
          !!(feature.name === "can_use_imper" && feature.value === "True")
      );
      return typeof canUseImper !== "undefined";
    },
    getHandoverStatus() {
      let string = "";

      switch (this.editedItem.handout_status.current_user) {
        case "PENDING_TRANSFER":
          string = this.$t("builder.boats.details.pending");
          break;
        case "INSTALLER":
          string = this.$t("builder.boats.details.installer");
          break;
        case "DEALER":
          string = this.$t("builder.boats.details.partner");
          break;
        case "CUSTOMER":
          string = this.$t("builder.boats.details.customer");
          break;
        case "NO_USER":
          string = this.$t("builder.boats.details.noUser");
          break;
      }
      return string;
    },
    // formTitle() {
    //   return this.editedIndex === -1
    //     ? this.$t("builder.boats.details.newBoatProfile")
    //     : this.$t("builder.boats.details.editBoatProfile");
    // },
    // showIndustrialCode() {
    //   return !!restrictions.canUseCrmFeature("has_industrial_codes");
    // },
    getBoatName() {
      if (this.editedItem.slot_number === null) {
        return `${this.editedItem.model.brand_name} ${this.editedItem.model.model}`;
      }
      return `${this.editedItem.model.brand_name} ${this.editedItem.model.model} #${this.editedItem.slot_number}`;
    },
    getSubscriptionStatus() {
      if (this.editedItem.billing_info == null) {
        return { status: null, valid_until: null, text: "" };
      }

      if (this.editedItem.billing_info.subscription == null) {
        return { status: null, valid_until: null, text: "" };
      }

      let subscription = this.editedItem.billing_info.subscription;
      let text = "";
      switch (subscription.status) {
        case "ACTIVATION_REQUIRED":
          if (
            this.editedItem.billing_info != null &&
            this.editedItem.billing_info.pin != null
          ) {
            text = this.$t(
              "builder.boats.details.activationRequiredUseActivationPIN",
              {
                pin: this.editedItem.billing_info.pin,
              }
            );
          } else {
            text = this.$t("builder.boats.details.activationRequired");
          }
          break;
        case "ACTIVE":
          text = this.$t("builder.boats.details.activeUntil", {
            date: this.$moment(subscription.valid_until)
              .toISOString()
              .substr(0, 10),
          });
          break;
        case "EXPIRED":
          text = this.$t("builder.boats.details.expired");
          break;
        case "INACTIVE":
          text = this.$t("builder.boats.details.inactive");
          break;
      }

      return {
        ...subscription,
        text: text,
      };
    },
    getRetrofitStatus() {
      let string = "";
      switch (this.editedItem.retrofit_status) {
        case "CONFIRMED":
          string = this.$t("builder.boats.details.retrofit");
          break;
        case "POTENTIAL":
          string = this.$t("builder.boats.details.unknown");
          break;
        default:
          string = this.$t("builder.boats.details.inFactory");
          break;
      }
      return string;
    },

    canSeeSalesDealer() {
      if (!this.editedItem.sales_dealer.uuid) {
        return false;
      }

      if (this.getMe.menu_access.dealers.visible) {
        return true;
      }

      let dealership = this.getMe.dealerships.find((dealership) => {
        return dealership.uuid === this.editedItem.sales_dealer.uuid;
      });

      if (typeof dealership === "undefined") {
        return false;
      }

      return true;
    },
    canSeeResponsiveDealer() {
      if (!this.editedItem.responsive_dealer.uuid) {
        return false;
      }

      if (this.getMe.menu_access.dealers.visible) {
        return true;
      }

      let dealership = this.getMe.dealerships.find((dealership) => {
        return dealership.uuid === this.editedItem.responsive_dealer.uuid;
      });

      if (typeof dealership === "undefined") {
        return false;
      }

      return true;
    },

    openSalesDealer() {
      if (this.editedItem.sales_dealer === null) {
        return "";
      }

      let routeData = this.$router.resolve({
        name: "partnerDetails",
        params: { id: this.editedItem.sales_dealer.uuid },
      });
      return routeData.href;
    },

    openResponsiveDealer() {
      if (this.editedItem.responsive_dealer === null) {
        return "";
      }

      let routeData = this.$router.resolve({
        name: "partnerDetails",
        params: { id: this.editedItem.responsive_dealer.uuid },
      });
      return routeData.href;
    },
  },

  created() {
    this.loading = true;
    this.categoryOptions = categories.categoryOptions();
    this.loadBoat();
  },

  methods: {
    editableFields(input) {
      if (typeof this.editedItem.editable_fields === "undefined") return true;
      if (this.editedItem.editable_fields.length === 0) return true;
      if (this.editedItem.editable_fields.includes("*")) return false;

      return !this.editedItem.editable_fields.find(
        (element) => element === input
      );
    },
    openCancelTransferDialog() {
      this.cancelTransferDialog.active = true;
    },
    handleCancelTransfer(event) {
      if (event) {
        api.cancelTransferBoat(this.$route.params.id).then((resp) => {
          this.loading = true;
          this.customItems = [];
          this.serialItems = [];
          this.loadBoat();
        });
      }
      this.cancelTransferDialog.active = false;
    },

    handleKycBanner(event) {
      this.kycBanner = { active: false, content: null };
      if (event === "reject") {
        this.close();
      } else if (event === "approve" || event === "reload") {
        this.loading = true;
        this.customItems = [];
        this.serialItems = [];
        this.loadBoat();
      }
    },
    openDiagnosticsReports() {
      this.diagnosticsReportDialog.active = true;
    },
    handleCloseDiagnosticsReport() {
      this.diagnosticsReportDialog.active = false;
    },
    handleImpersonate() {
      if (!this.editedItem.is_imper_in_use) {
        api.boatImpersonate(this.$route.params.id).then((resp) => {
          this.editedItem.is_imper_in_use = true;
          snackbar.success(
            this.$t("utils.snackbar.success.temporaryAccessEnabled"),
            false
          );
        });
      } else {
        snackbar.success(
          this.$t("utils.snackbar.success.temporaryAccessIsAlreadyEnabled"),
          false
        );
      }
    },
    reset() {
      this.resetDialog.sentinelSn = this.editedItem.device.name;
      this.resetDialog.active = true;
    },
    handleReset(event) {
      if (!event) {
        this.resetDialog.active = false;
        return;
      }

      this.loading = true;
      api
        .resetBoat(this.editedItem.uuid)
        .then((resp) => {
          this.close();
        })
        .catch((err) => {
          snackbar.error(
            err.response.data[Object.keys(err.response.data)[0]][0]
          );
        });
    },
    refresh() {
      this.loading = true;
      api
        .importBoatFromMis(
          { device_serial: this.editedItem.device.name },
          { update_existing: true }
        )
        .then((resp) => {
          this.loadBoat();
        })
        .catch((err) => {
          snackbar.error(
            err.response.data[Object.keys(err.response.data)[0]][0]
          );
        });
    },
    updateRetrofitBanner(boat) {
      this.editedItem = boat;
      if (boat.billing_info.pin) {
        this.showPinBanner = {
          ...this.showPinBanner,
          pin: boat.billing_info.pin,
          active: true,
        };
      }
      this.showRetrofitStatus.active = false;
    },
    handleQrPreviewDialog(event) {
      this.qrPreviewDialog.active = false;
    },
    previewQrCode() {
      this.qrPreviewDialog.boat = this.editedItem;
      this.qrPreviewDialog.src = this.$refs.qrCode.$el.currentSrc;
      this.qrPreviewDialog.active = true;
    },
    openTransferDialog() {
      this.transferDialog = {
        active: true,
        activeUser: this.editedItem.handout_status.current_user_email,
      };
    },
    handleTransferDialog(event, transferHistoricalData, language) {
      if (event) {
        api
          .transferBoat(
            this.$route.params.id,
            { email: event, language: language },
            { transfer_history: transferHistoricalData }
          )
          .then((resp) => {
            this.loading = true;
            this.customItems = [];
            this.serialItems = [];
            this.loadBoat();
          });
      }
      this.transferDialog = {
        active: false,
        activeUser: null,
      };
    },

    loadBoat() {
      let promises = [
        api.getBoatItems(this.$route.params.id, false),
        api.getBoat(this.$route.params.id, false),
      ];

      Promise.all(promises)
        .then((values) => {
          this.$set(this.initialBoatItemsData, "data", values[0].data);
          this.model = values[1].data.model;

          const retrofitStatus = values[1].data.retrofit_status;
          const billingInfo = values[1].data.billing_info;

          if (retrofitStatus === "POTENTIAL") {
            this.showRetrofitStatus = {
              active: true,
              showPin: false,
              pin: null,
            };
          } else {
            if (billingInfo.pin) {
              this.showPinBanner = {
                ...this.showPinBanner,
                pin: billingInfo.pin,
                active: true,
              };
            }
          }

          delete values[1].data.boat_items;
          this.editedItem = values[1].data;

          if (this.editedItem.device != null) {
            if (
              typeof this.editedItem.device.qr_hash !== "undefined" &&
              this.editedItem.device.qr_hash != null
            ) {
              this.editedItem.device.qr_hash = `https://www.sentinel.app/qr/${this.editedItem.device.qr_hash}`;
            }
          }

          this.serialDocuments = this.editedItem.model.documents;
          this.customDocuments = this.editedItem.documents;
          this.getDealersUuid = {
            responsive_dealer:
              typeof this.editedItem.responsive_dealer.uuid !== "undefined"
                ? this.editedItem.responsive_dealer.uuid
                : null,
            sales_dealer:
              typeof this.editedItem.sales_dealer.uuid !== "undefined"
                ? this.editedItem.sales_dealer.uuid
                : null,
            active_user:
              this.editedItem.handout_status !== null &&
              this.editedItem.handout_status.current_user !== "PENDING_TRANSFER"
                ? this.editedItem.handout_status.current_user_email
                : null,
          };

          if (
            typeof this.editedItem.pending_kyc !== "undefined" &&
            this.editedItem.pending_kyc !== null
          ) {
            this.kycBanner = {
              active: true,
              content: this.editedItem.pending_kyc,
              slot_number: !!this.editedItem.slot_number,
              delivery_date: !!this.editedItem.delivery_date_to_customer,
              responsive_dealer:
                typeof this.editedItem.responsive_dealer.uuid !== "undefined",
            };
          }
          this.loading = false;
        })
        .catch((err) => {
          console.error(err);
          snackbar.error();
          this.close();
        });
    },

    applyProfile(confirmed) {
      if (confirmed) {
        this.warningDialog = false;
        api.applyProfile(this.$route.params.id);

        this.profileApplied = true;
      } else {
        this.warningDialog = true;
      }
    },
    close() {
      this.$router.push({
        name: "boats",
      });
    },
    edit() {
      this.$router.push({
        name: "boatsEdit",
        params: { id: this.$route.params.id },
      });
    },

    deleteFn() {
      this.deleteDialog = true;
      this.boatName =
        this.editedItem.model.brand_name + " " + this.editedItem.model.model;
    },

    remove(agreed) {
      if (agreed) {
        api.deleteBoat(this.editedItem.uuid).then((resp) => {
          this.$router.push({
            name: "boats",
          });
        });
      }
      this.deleteDialog = false;
    },
  },
};
</script>
